import { NORECORDS } from "../../../Services/CommonLibrary";
import {formatUkNumber} from "../../Utils";

export default ({ loading, data, isClinic = true,loadingMessage="Loading divison data..." }) => {
    if (loading) {
        return <div className="text-center my-5">
            <div
                style={{ color: "#535f7e" }}
                className="spinner-border"
                role="status"
            >
                <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">{loadingMessage}</p>
        </div>;
    }

    if (data.length == 0) {
        return <NORECORDS marginTop="100px" />;
    }
    return <>
        <div
            style={{
                maxHeight: "400px",
                overflowY: "auto",
                backgroundColor: "#fff",
            }}
        >

            <table className="table table-bordered mt-4">
                <thead className="table-light">
                    <tr>
                        <th className="bg-white font-bold">Name</th>
                        <th className="bg-white font-bold">Account Created</th>
                        <th className="bg-white font-bold">Fully Onboarded</th>
                        {isClinic &&
                            <th className="bg-white font-bold">
                                In-clinic Appointments (Completed)
                            </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => {
                        return (
                            <tr key={`division_${index}`}>
                                <td>{item["name"]}</td>
                                <td>{formatUkNumber(item["cnt"])}</td>
                                <td>{formatUkNumber(item["onboardedUser"])}</td>
                                {isClinic &&
                                    <td>{formatUkNumber(item["inclinic"])}</td>
                                }
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    </>;
}